import {init, setOptOut} from '@amplitude/analytics-browser';
import apiConfig from '~Configs/apiConfig';

export const initAmplitude = () => {
  if (apiConfig.amplitude.apiKey) {
    init(apiConfig.amplitude.apiKey, undefined, {
      logLevel: apiConfig.amplitude.debugLevel || 0,
      serverZone: 'EU',
      // Disable Amplitude autocapture page-views: the explicit `page_viewed`
      // catalog event is the single source of truth for page views. Leaving
      // autocapture on caused every navigation to be counted multiple times
      // (autocapture "[Amplitude] Page Viewed" + our manual event). Sessions and
      // attribution autocapture stay enabled (unspecified keys keep their default).
      defaultTracking: {
        pageViews: false,
      },
    });
    // Anonymous-by-default policy: web auto-consents logged-out users so
    // baseline engagement tracking works without a consent gate. Once the
    // user logs in, DidomiInitProvider re-evaluates and applies the
    // logged-in consent choice via setOptOut().
    setOptOut(false);
  }
};
